import api from "../axiosIntercepture";

// 🔹 Fetch Door Locations (with pagination)
export const fetchDoorlocs = async (page = 0, pageSize = 10) => {
  try {
    const response = await api.post(
      "/door-location/getDoorLocations",
      {},
      {
        params: { page: page + 1, limit: pageSize },
      }
    );

    return response.data?.data;
  } catch (err) {
    throw err?.response?.data?.message || "Failed to fetch door locations";
  }
};


export const fetchDoorlocById = async (id) => {
    try {
        const response = await api.post(
            `/door-location/getDoorLocations?id=${id}`,
            {}
        );
        return response.data?.data?.data?.[0] || null;
    } catch (err) {
        throw err?.response?.data?.message || "Failed to fetch adjustment";
    }
};
